import React from "react";
import { aboutContent } from "@/mock/siteContent";

const About = () => {
  return (
    <div>
      <section data-testid="about-header" style={{ borderBottom: "1px solid var(--border)", padding: "64px 24px 48px", maxWidth: 1140, margin: "0 auto" }}>
        <p style={{ fontFamily: "'DM Mono', monospace", fontSize: "0.62rem", letterSpacing: "0.2em", color: "var(--gold)", textTransform: "uppercase", marginBottom: 14, display: "flex", alignItems: "center", gap: 8 }}>
          <span style={{ width: 20, height: 1, background: "var(--gold)", display: "inline-block" }} />
          Quem somos
        </p>
        <h1 data-testid="about-title" style={{ fontFamily: "'Syne', sans-serif", fontWeight: 600, fontSize: "clamp(1.8rem, 3.5vw, 2.6rem)", color: "var(--text)", letterSpacing: "-0.01em", maxWidth: 640 }}>
          {aboutContent.title}
        </h1>
      </section>
      <section data-testid="about-content" className="grid-about" style={{ maxWidth: 1140, margin: "0 auto", padding: "64px 24px", display: "grid", gridTemplateColumns: "minmax(0, 1.5fr) minmax(0, 1fr)", gap: 64, alignItems: "start" }}>
        <div>
          <p style={{ fontSize: "1.05rem", color: "var(--muted)", lineHeight: 1.7, marginBottom: 28 }}>{aboutContent.intro}</p>
          <div style={{ borderLeft: "2px solid var(--gold)", paddingLeft: 20, marginBottom: 32 }}>
            <p style={{ fontSize: "0.875rem", color: "var(--muted)", lineHeight: 1.75, fontStyle: "italic" }}>
              "Modelos estruturados, fluxos definidos e documentação clara para quem projeta e para quem executa."
            </p>
          </div>
          {aboutContent.paragraphs.map((p, i) => (
            <p key={i} style={{ fontSize: "0.9rem", color: "var(--muted)", lineHeight: 1.75, marginBottom: 16 }}>{p}</p>
          ))}
        </div>
        <div style={{ background: "var(--surface)", border: "1px solid var(--border)", borderRadius: 8, overflow: "hidden" }}>
          <div style={{ padding: "20px 24px", borderBottom: "1px solid var(--border)", display: "flex", alignItems: "center", gap: 8 }}>
            <span style={{ width: 8, height: 8, borderRadius: "50%", background: "var(--gold)", display: "inline-block" }} />
            <span style={{ fontFamily: "'DM Mono', monospace", fontSize: "0.62rem", letterSpacing: "0.16em", color: "var(--muted2)", textTransform: "uppercase" }}>Foco da atuação</span>
          </div>
          {aboutContent.highlights.map((item, i) => (
            <div key={item.label} style={{ padding: "20px 24px", borderBottom: i < aboutContent.highlights.length - 1 ? "1px solid var(--border)" : "none" }}>
              <div style={{ fontFamily: "'Syne', sans-serif", fontWeight: 700, fontSize: "0.85rem", color: "var(--gold)", marginBottom: 6, letterSpacing: "0.03em" }}>{item.label}</div>
              <p style={{ fontSize: "0.82rem", color: "var(--muted)", lineHeight: 1.6 }}>{item.description}</p>
            </div>
          ))}
        </div>
      </section>
      <section data-testid="about-values" style={{ borderTop: "1px solid var(--border)", background: "var(--surface)", padding: "48px 24px" }}>
        <div className="grid-values" style={{ maxWidth: 1140, margin: "0 auto", display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: 1, background: "var(--border)" }}>
          {[
            { icon: "\u25C8", title: "Rigor técnico", text: "Padrões de modelagem e critérios de LOD definidos antes de qualquer entrega." },
            { icon: "\u2B21", title: "Transparência", text: "Relatórios técnicos objetivos em cada etapa do projeto." },
            { icon: "\u25C7", title: "Foco em obra", text: "Modelos orientados a decisões reais — não apenas visualização." },
          ].map((v) => (
            <div key={v.title} style={{ background: "var(--bg)", padding: "32px 28px", textAlign: "center" }}>
              <div style={{ fontSize: "1.6rem", color: "var(--gold)", marginBottom: 12, opacity: 0.7 }}>{v.icon}</div>
              <h3 style={{ fontFamily: "'Syne', sans-serif", fontWeight: 700, fontSize: "0.95rem", color: "var(--text)", marginBottom: 8 }}>{v.title}</h3>
              <p style={{ fontSize: "0.82rem", color: "var(--muted)", lineHeight: 1.65 }}>{v.text}</p>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default About;
